import React from 'react';
import PropTypes from 'prop-types';
import StatusBanner from './StatusBanner';
import * as Tools from "../../helpers/Tools";

const propTypes = {
    children: PropTypes.node,    // anything that can be rendered, such as numbers, string, DOM elements, arrays, or fragments   
    heading: PropTypes.string,   // Error Heading.
    icon: PropTypes.string,       // Alternative Heading Icon
    subBannerMsg: PropTypes.string // Error subBannerMsg
};

class ErrorPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && Tools.isMobile()) {
            window.scrollTo(0, 0);
        }
    }
    render() {
        const { icon, heading, children, subBannerMsg, bannerAlignment} = this.props;
        return (<div className="container-fluid body-content errorbanner-status-container">
            <div className="row">
                <div className="col-12">
                    <StatusBanner bannerAlignment={bannerAlignment ? bannerAlignment : "center"} statusIcon={icon} bannerMsg={heading} failedStatus subBannerMsg={subBannerMsg}>
                        {children && <span>{children}</span>}
                    </StatusBanner>
                </div>
            </div>
        </div>);
    }
}

ErrorPage.propTypes = propTypes;
export default ErrorPage;